import {
  baseQueryParamMapping,
  defaultReportingPeriod,
} from '@/components/core/analytics/queryParamMapping';
import { getMetrics, METRICS } from '@/models/metrics.enum';
import { PLATFORM_CONNECTION } from '@/models/platform/platform-connection.enum';

export const useYourPosts = () => {
  const metrics = getMetrics('yourPosts');

  return {
    title: 'X Posts',
    channelFilterKey: 'twitter',
    filters: {
      brandMediaTypes: ['TWITTER_OWNED', 'TWITTER_OWNED_LINK', 'TWITTER_OWNED_TEXT'],
      default: {
        captionContain: [],
        captionNotContain: [],
        contentTags: [],
        contentTagMatchType: 'ANY',
        postType: [],
        reportingPeriod: defaultReportingPeriod,
        sort: {
          sortOrder: 'DESC',
          selected: { value: 'DATE', label: 'Recently Published' },
        },
      },
      options: {
        postType: [
          { label: 'Photo', value: 'PHOTO' },
          { label: 'Video', value: 'VIDEO' },
          { label: 'Carousel', value: 'CAROUSEL' },
          { label: 'Text', value: 'TEXT' },
          { label: 'Link', value: 'LINK' },
        ],
      },
      queryParamMapping: {
        ...baseQueryParamMapping,
        postType: { queryParamName: 'postType', type: 'array', elementType: 'string' },
        captionContain: {
          queryParamName: 'captionContain',
          type: 'array',
          elementType: 'string',
        },
        captionNotContain: {
          queryParamName: 'captionNotContain',
          type: 'array',
          elementType: 'string',
        },
      },
      scope: 'twitterYourPosts',
      sortDetails: {
        options: [
          { label: 'Recently Published', value: 'DATE' },
          {
            title: 'Organic + Promoted',
            children: metrics.all([
              METRICS.TWITTER.ENGAGEMENT_RATE,
              METRICS.TWITTER.IMPRESSIONS,
              METRICS.TWITTER.LIKES,
              METRICS.TWITTER.LINK_CLICKS,
              METRICS.TWITTER.PROFILE_CLICKS,
              METRICS.TWITTER.QUOTE_POSTS,
              METRICS.TWITTER.REPLIES,
              METRICS.TWITTER.REPOSTS,
              METRICS.TWITTER.ENGAGEMENTS,
              METRICS.TWITTER.TOTAL_REPOSTS,
              METRICS.TWITTER.USER_FOLLOWS,
              METRICS.TWITTER.VIDEO_VIEWS,
            ]),
          },
        ],
        default: {
          sortOrder: 'DESC',
          selected: { value: 'DATE', label: 'Recently Published' },
        },
      },
    },
    displayMetrics: metrics.all([
      METRICS.TWITTER.ENGAGEMENT_RATE,
      METRICS.TWITTER.ENGAGEMENTS,
      METRICS.TWITTER.IMPRESSIONS,
      METRICS.TWITTER.LIKES,
    ]),
    metricLabels: metrics.all(Object.values(METRICS.TWITTER)),
    download: {
      pdf: {
        fileName: 'yourTwitterPostsPDF',
        type: 'twitterYourPosts',
        label: 'Your X Posts PDF',
        pendingKey: 'twitterYourPostsReportPending',
      },
      csv: {
        fileName: 'yourTwitterPostsCSV',
        type: 'twitterYourPosts',
        label: 'Your X Posts CSV',
        pendingKey: 'twitterYourPostsCSVPending',
      },
    },
    platformConnection: PLATFORM_CONNECTION.TWITTER,
  };
};
